import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { TableComponent } from './table/table.component';
import { AddTrainingComponent } from './add-training/add-training.component';
import { ManageTrainingComponent } from './manage-training/manage-training.component';
import { UsersComponent } from './users/users.component';
import { TrainingPreviewComponent } from './training-preview/training-preview.component';
import { TrainingDashboardComponent } from './training-dashboard/training-dashboard.component';
import { GroupsComponent } from '../app/dms/groups/groups.component';
import { GroupUsersComponent } from '../app/dms/group-users/group-users.component';
import { DocumentTemplateComponent } from '../app/dms/document-template/document-template.component';
import { CodelistComponent } from './admin/codelist/codelist.component';
import { LaunchTrainingComponent } from './launch-training/launch-training.component';
import { ReasonForSignatureTemplateComponent } from './reason-for-signature-template/reason-for-signature-template.component';
import { TrainingParameterTemplateComponent } from '../app/tms/training-parameter-template/training-parameter-template.component';
import { TrainingReviewPeriodComponent } from '../app/lms/training-review-period/training-review-period.component';
import { TmsSettingsComponent } from './admin/tms-settings/tms-settings.component';
import { ProductCountriesComponent } from '../app/qms/product-countries/product-countries.component';
import { ProductMasterComponent } from '../app/qms/product-master/product-master.component';
import { VendorsComponent } from '../app/qms/vendors/vendors.component';
import { DocumenttypeComponent } from './documenttype/documenttype.component';
import { trainingTypeResolver } from './add-training/trainingTypeResolver';
import { languageResolver } from './add-training/languageResolver';
import { QmsgroupsComponent } from './qmsgroups/qmsgroups.component';
import { GroupusersComponent } from './qmsgroups/groupusers/groupusers.component';
import { CRComponent } from './qms/cr/cr.component';
import { ActivityGridComponent } from './qms/activity-grid/activity-grid.component';
import { TmsGroupsComponent } from './tms/tms-groups/tms-groups.component';
import { TmsGroupDetailComponent } from './tms/tms-groups/tms-group-detail/tms-group-detail.component';
import { TrainingDashboardDetailComponent } from './training-dashboard/training-dashboard-detail/training-dashboard-detail.component';
import { QmsReportTemplateComponent } from './qms-report-template/qms-report-template.component'
import { QmsReporttemplateSectionfieldComponent } from './qms-reporttemplate-sectionfield/qms-reporttemplate-sectionfield.component'
import { TaskDocumentsComponent } from './qms/task-documents/task-documents.component';
import { QmsQuestionnaireTemplateComponent } from './qms-questionnaire-template/qms-questionnaire-template.component';
import { QmsQuestionnaireTemplateQuestionComponent } from './qms-questionnaire-template-question/qms-questionnaire-template-question.component';
import { DmsRootFolderComponent } from './dms-root-folder/dms-root-folder.component';
import { DmsSubFolderComponent } from './dms-sub-folder/dms-sub-folder.component';
import { AddDocumentComponent } from './dms-sub-folder/add-document/add-document.component';
import { OneqmsOrganizationComponent } from './oneqms-organization/oneqms-organization.component';
import { TaskExtensionsComponent } from './qms/task-extensions/task-extensions.component';
import { QmsBusinessareaComponent } from './admin/qms-businessarea/qms-businessarea.component';
import { TasksEcComponent } from './qms/tasks-ec/tasks-ec.component';
import { MyTasksComponent } from './my-tasks/my-tasks.component';
import { OneqmsTopicsComponent } from './oneqms-topics/oneqms-topics.component';
import { CapaComponent } from '../app/qms/capa/capa.component';
import { DvComponent } from '../app/qms/dv/dv.component';
import { RaiseInComponent } from './qms/raise-in/raise-in.component';
import { InComponent } from './qms/in/in.component';
import { TmsUserTrainingsReportComponent } from './tms-user-trainings-report/tms-user-trainings-report.component';
import { RaiseCcComponent } from './qms/raise-cc/raise-cc.component';
import { CcComponent } from './qms/cc/cc.component';
import { TmsUserManageTrainingsReportComponent } from './tms-user-manage-trainings-report/tms-user-manage-trainings-report.component';
import { ScheduledTrainingsComponent } from './scheduled-trainings/scheduled-trainings.component';
import { ScheduledTrainingDetailsComponent } from './scheduled-trainings/scheduled-training-details/scheduled-training-details.component';
import { CcpComponent } from './qms/ccp/ccp.component';
import { AuMasterComponent } from './qms/au/au-master/au-master.component';
import { AuComponent } from './qms/au/au.component';
import { AuDetailPageComponent } from './qms/au/au-detail-page/au-detail-page.component';
import { TmsUserTrainingReviewPeriodComponent } from './tms-user-training-review-period/tms-user-training-review-period.component';
import { AuQuestionsComponent } from './qms/au/au-questions/au-questions.component';
import { BadgeRangesComponent } from './tms/badge-ranges/badge-ranges.component';
import { TmsUserTrainingReviewPeriodEditComponent } from './tms-user-training-review-period-edit/tms-user-training-review-period-edit.component';
import { TeamTrainingsComponent } from './training-dashboard/team-trainings/team-trainings.component';
import { AuFindingDetailsComponent } from './qms/au/au-finding-details/au-finding-details.component';
import { InvestigationTechniqueTemplateComponent } from '../app/qms/investigation-technique-template/investigation-technique-template.component';
import { DvParticipantsComponent } from '../app/qms/dv-participants/dv-participants.component';
import { ActivityReportComponent } from './activity-report/activity-report.component';
import { QiComponent } from './qms/qi/qi.component'; import { MoreActivityReportDetailsComponent } from './more-activity-report-details/more-activity-report-details.component';
import { PickQuestionsComponent } from './qms/au/pick-questions/pick-questions.component';
import { SchedulersComponent } from './schedulers/schedulers.component';
import { SchedulersDetailComponent } from './schedulers/schedulers-detail/schedulers-detail.component';
import { OneQmsAdminReportComponent } from './one-qms-admin-report/one-qms-admin-report.component';
import { OneQmsMoreAdminReportDetailsComponent } from './one-qms-more-admin-report-details/one-qms-more-admin-report-details.component';
import { DMSReportsComponent } from './dms-reports/dms-reports.component';
import { RiskScaleComponent } from './qms/risk-scale/risk-scale.component';
import { RiskSettingsComponent } from './qms/risk-settings/risk-settings.component';
import { LocationMasterComponent } from './qms/location-master/location-master.component';
import { DmsNotificationSettingsComponent } from './notification-settings/dms-notification-settings/dms-notification-settings.component';
import { TmsNotificationSettingsComponent } from './notification-settings/tms-notification-settings/tms-notification-settings.component';
import { QmsNotificationSettingsComponent } from './notification-settings/qms-notification-settings/qms-notification-settings.component';
import { LoginAdComponent } from './login-ad/login-ad.component';
import { MsalGuard } from '@azure/msal-angular';
import { DocumentIssuanceHistoryComponent } from './dms/document-issuance-history/document-issuance-history.component';
import { AfterLoginComponent } from './after-login/after-login.component';
import { DmsSearchDocumentComponent } from './dms-search-document/dms-search-document.component';
import { RegisterOrgComponent } from './organization/create-or-upgrade-org/register-org/register-org.component';
import { CreateOrUpgradeOrgComponent } from './organization/create-or-upgrade-org/create-or-upgrade-org.component';
import { ManageOrganizationComponent } from './organization/manage-organization/manage-organization.component';
import { HomepageComponent } from './homepage/homepage.component';
import { LoginAdTempComponent } from './login-ad-temp/login-ad-temp.component';
import { LoginnonADComponent } from './loginnon-ad/loginnon-ad.component';
import { TrainingCertificateTemplateComponent } from './tms/training-certificate-template/training-certificate-template.component';
import { TmsReportsComponent } from './tms-reports/tms-reports.component';
import { FormTemplatesComponent } from './formsLogsSetup/form-templates/form-templates.component';
import { FormTemplateDetailComponent } from './formsLogsSetup/form-template-detail/form-template-detail.component';
import { FomsLogsImplementationComponent } from './foms-logs-implementation/foms-logs-implementation.component';
import { FormsLogsDetailComponent } from './foms-logs-implementation/forms-logs-detail/forms-logs-detail.component';
import { FileLaunchComponent } from './file-launch/file-launch.component';
import { DmsMainReportComponent } from './dms-main-report/dms-main-report.component';
import { DrModeComponent } from './organization/dr-mode/dr-mode.component';
import { AuditReportFindingDetailComponent } from './audit-report-finding-detail/audit-report-finding-detail.component';
import { OveralldashboardComponent } from './qms/overalldashboard/overalldashboard.component';
import { FindingDueDateComponent } from './finding-due-date/finding-due-date.component';
import { FollowupDueDateComponent } from './followup-due-date/followup-due-date.component';
import { CalendarComponent } from './calendar/calendar.component';
import { countryResolver } from './calendar/CountryResolver';
import { calendarResolver } from './calendar/calendarResolver';
import { UserNotificationsComponent } from './notifications/notifications.component';
import { FlexibleFieldsSetupComponent } from './admin/flexible-fields-setup/flexible-fields-setup.component';
import { OrgnizationResolver } from './calendar/organizationResolver';
import { OneQMSDashboardComponent } from './one-qms-dashboard/one-qms-dashboard.component';
import { TrainingsConclusiveTrailComponent } from './support/trainings-conclusive-trail/trainings-conclusive-trail.component';
import { ParallelWorkflowDetailComponent } from './qms/parallel-workflow/parallel-workflow-detail/parallel-workflow-detail.component';
import { FormsAndLogsReportsComponent } from './forms-and-logs-reports/forms-and-logs-reports.component';
import { FormsAndLogsMoreReportsComponent } from './forms-and-logs-more-reports/forms-and-logs-more-reports.component';
import { FeedbackTemplateComponent } from './feedback-template/feedback-template.component';
import { FeedbackTemplateDetailComponent } from './feedback-template/feedback-template-detail/feedback-template-detail.component';
import { VendorDetailsComponent } from './qms/vendor-details/vendor-details.component';
import { DocumentHeaderTemplateComponent } from './dms/document-header-template/document-header-template.component'; import { OosComponent } from './qms/oos/oos.component';
import { OosLabInvestigationTemplateComponent } from './admin/oos-lab-investigation/oos-lab-investigation-template/oos-lab-investigation-template.component';
import { OosLabInvestigationCategoryComponent } from './admin/oos-lab-investigation/oos-lab-investigation-category/oos-lab-investigation-category.component';
import { QmsSettingsVwComponent } from './admin/qms-settings-vw/qms-settings-vw.component';
import { DmsSettingsComponent } from './admin/dms-settings/dms-settings.component';
import { ImpactAssessmentTemplateComponent } from './admin/impact-assessment/impact-assessment-template/impact-assessment-template.component';
import { ImpactAssessmentFieldsComponent } from './admin/impact-assessment/impact-assessment-fields/impact-assessment-fields.component';
import { InstrumentMasterComponent } from './admin/instrument-master/instrument-master.component'
import { ChecklistTemplateComponent } from './admin/check-list/checklist-template/checklist-template.component';
import { ChecklistFieldsComponent } from './admin/check-list/checklist-fields/checklist-fields.component';
import { DocumentDownloadTemplateComponent } from './dms/document-download-template/document-download-template.component';
import { DocumentDestructionsHistoryComponent } from './document-destructions-history/document-destructions-history.component';
import { OrgPrintersComponent } from './admin/org-printers/org-printers.component'
import { AuthGuard } from './core/guards/auth.guard';
import { EsignatureSetupComponent } from './esignature-setup/esignature-setup.component';
import { EsignatureSignComponent } from './esignature-sign/esignature-sign.component';


const routes: Routes = [
  {
    path: 'profile',
    component: AfterLoginComponent,
    canActivate: [MsalGuard],
    children: [
      {
        path: '',
        component: MyTasksComponent
      }]

  },
  {
    path: 'loginorg',
    component: LoginnonADComponent,
  },
  {
    path: 'login',
    component: LoginComponent,
  },

  {
    path: 'logins',
    component: LoginAdComponent,
    canActivate: [MsalGuard]
  },
  {
    path: 'login/:name',
    component: LoginAdTempComponent
  },
  {
    path: 'launchvalidate/:details',
    component: FileLaunchComponent
  },
  {
    path: 'preview',
    component: TrainingPreviewComponent
  },
  {
    path: 'launchTraining',
    component: LaunchTrainingComponent
  },
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    /* runGuardsAndResolvers: 'always', */

    resolve: {
      calendarEvent: calendarResolver,
      orgDetails: OrgnizationResolver,
      countries: countryResolver
    },


    children: [
      {
        path: '',
        component: HomepageComponent
      },
      {
        path: 'MyTasks',
        component: MyTasksComponent
      },
      {
        path: 'trainingDashboard',
        component: TrainingDashboardComponent
      },

      {
        path: 'table',
        component: TableComponent
      },
      {
        path: 'manageTraining/:name',
        component: ManageTrainingComponent
      },

      {
        path: 'users',
        component: UsersComponent,
        children: [
          {
            path: 'table',
            component: TableComponent
          }
        ]
      }, {
        path: 'flexfieldSetup',
        component: FlexibleFieldsSetupComponent
      }, {
        path: 'trainingsConclusiveTrail',
        component: TrainingsConclusiveTrailComponent
      }, {
        path: 'groups',
        component: GroupsComponent
      }, {
        path: 'groupUsers',
        component: GroupUsersComponent
      }, {
        path: 'documentTemplates',
        component: DocumentTemplateComponent
      }, {
        path: 'codelists',
        component: CodelistComponent
      }, {
        path: 'trainingParameterTemplate',
        component: TrainingParameterTemplateComponent
      }, {
        path: 'documentDownloadTemplate',
        component: DocumentDownloadTemplateComponent
      }, {
        path: 'reasonForSignatureTemplate',
        component: ReasonForSignatureTemplateComponent
      }, {
        path: 'trainingReviewPeriod',
        component: TrainingReviewPeriodComponent
      }, {
        path: 'qmsSettings',
        component: QmsSettingsVwComponent
      }, {
        path: 'tmsSettings',
        component: TmsSettingsComponent
      }, {
        path: 'dmsSettings',
        component: DmsSettingsComponent
      }, {
        path: 'productMaster',
        component: ProductMasterComponent
      }, {
        path: 'productCountries',
        component: ProductCountriesComponent
      },
      {
        path: 'addTraining',
        component: AddTrainingComponent,
        resolve: {
          trainingType: trainingTypeResolver,
          languageForTraining: languageResolver
        }
      }, {
        path: 'vendors',
        component: VendorsComponent
      }, {
        path: 'vendorDetails',
        component: VendorDetailsComponent
      }, {
        path: 'documenttype',
        component: DocumenttypeComponent
      }, {
        path: 'qmsGroups',
        component: QmsgroupsComponent
      }, {
        path: 'qmsgroupUsers',
        component: GroupusersComponent
      }, {
        path: 'qmsCr',
        component: CRComponent
      }, {
        path: 'ActivityCR/:name',
        component: ActivityGridComponent
      }, {
        path: 'qmsReportTemplate',
        component: QmsReportTemplateComponent
      }, {
        path: 'qmsReportTemplateSectionField',
        component: QmsReporttemplateSectionfieldComponent
      }, {
        path: 'trainingGroups',
        component: TmsGroupsComponent
      }, {
        path: 'trainingGroupDetail',
        component: TmsGroupDetailComponent
      }, {
        path: 'taskDocuments',
        component: TaskDocumentsComponent
      }, {
        path: 'qmsQuestionnaireTemplate',
        component: QmsQuestionnaireTemplateComponent
      }, {
        path: 'qmsQuestionnaireTemplateQuestion',
        component: QmsQuestionnaireTemplateQuestionComponent
      }, {
        path: 'trainingDashboardDetail',
        component: TrainingDashboardDetailComponent
      }, {
        path: 'rootFolder',
        component: DmsRootFolderComponent
      }, {
        path: 'subFolder/:name',
        component: DmsSubFolderComponent
      }, {
        path: 'addDocument',
        component: AddDocumentComponent
      }, {
        path: 'oneqmsOrganization',
        component: OneqmsOrganizationComponent
      }, {
        path: 'taskExtensions',
        component: TaskExtensionsComponent
      }, {
        path: 'qmsBusinessArea',
        component: QmsBusinessareaComponent
      }, {
        path: 'qmsTasksEc',
        component: TasksEcComponent
      }, {
        path: 'oneqmsTopics',
        component: OneqmsTopicsComponent
      }, {
        path: 'capa',
        component: CapaComponent
      }, {
        path: 'dv',
        component: DvComponent
      }, {
        path: 'raiseIn',
        component: RaiseInComponent
      }, {
        path: 'in',
        component: InComponent
      }, {
        path: 'qi',
        component: QiComponent
      }, {
        path: 'raiseCc',
        component: RaiseCcComponent
      }, {
        path: 'cc',
        component: CcComponent
      }, {
        path: 'tmsUserTrainingsReport',
        component: TmsUserTrainingsReportComponent
      }, {
        path: 'TmsUserManageTrainingsReport',
        component: TmsUserManageTrainingsReportComponent
      }, {
        path: 'scheduledTrainings',
        component: ScheduledTrainingsComponent
      }, {
        path: 'scheduleTrainingDetail',
        component: ScheduledTrainingDetailsComponent
      }, {
        path: 'auMaster',
        component: AuMasterComponent
      }, {
        path: 'au',
        component: AuComponent
      }, {
        path: 'ccProducts',
        component: CcpComponent
      }, {
        path: 'auDetailPage',
        component: AuDetailPageComponent
      }, {
        path: 'auQuestions',
        component: AuQuestionsComponent
      }, {
        path: 'pickQuestions',
        component: PickQuestionsComponent
      }, {
        path: 'trainingBadge',
        component: BadgeRangesComponent
      }, {
        path: 'TmsUserTrainingReviewPeriodComponent',
        component: TmsUserTrainingReviewPeriodComponent
      }, {
        path: 'TmsUserTrainingReviewPeriodEditComponent',
        component: TmsUserTrainingReviewPeriodEditComponent
      }, {
        path: 'teamTrainings',
        component: TeamTrainingsComponent
      }, {
        path: 'auFindingDetails',
        component: AuFindingDetailsComponent
      }, {
        path: 'investigationTechniqueTemplateComponent',
        component: InvestigationTechniqueTemplateComponent
      }, {
        path: 'dvParticipantsComponent',
        component: DvParticipantsComponent
      }, {
        path: 'ActivityReportComponent/:name',
        component: ActivityReportComponent
      }, {
        path: 'MoreActivityReportDetailsComponent/:name',
        component: MoreActivityReportDetailsComponent
      }, {
        path: 'schedulers',
        component: SchedulersComponent
      }, {
        path: 'schedulersDetail',
        component: SchedulersDetailComponent
      }, {
        path: 'OneQmsAdminReportComponent',
        component: OneQmsAdminReportComponent
      }, {
        path: 'OneQmsMoreAdminReportDetailsComponent',
        component: OneQmsMoreAdminReportDetailsComponent
      }, {
        path: 'DMSReportsComponent',
        component: DMSReportsComponent
      }, {
        path: 'riskScaleComponent',
        component: RiskScaleComponent
      }, {
        path: 'riskSettingsComponent',
        component: RiskSettingsComponent
      }, {
        path: 'locationMasterComponent',
        component: LocationMasterComponent
      }, {
        path: 'dmsNotificationSettings',
        component: DmsNotificationSettingsComponent
      }, {
        path: 'tmsNotificationSettings',
        component: TmsNotificationSettingsComponent
      }, {
        path: 'qmsNotificationSettings',
        component: QmsNotificationSettingsComponent
      }, {
        path: 'documentIssuanceHistory',
        component: DocumentIssuanceHistoryComponent
      }, {
        path: 'documentDestructionsHistory',
        component: DocumentDestructionsHistoryComponent
      }, {
        path: 'documentSearch',
        component: DmsSearchDocumentComponent
      }, {
        path: 'register',
        component: RegisterOrgComponent
      }, {
        path: 'createOrg/:operation',
        component: CreateOrUpgradeOrgComponent
      }, {
        path: 'manageOrg',
        component: ManageOrganizationComponent
      }, {
        path: 'trainingCertificateTemplate',
        component: TrainingCertificateTemplateComponent
      }, {
        path: 'tmsReport',
        component: TmsReportsComponent

      }, {
        path: 'formsAndLogsTemplate',
        component: FormTemplatesComponent

      }, {
        path: 'formTemplateDetail',
        component: FormTemplateDetailComponent

      }, {
        path: 'formsAndLogs',
        component: FomsLogsImplementationComponent

      }, {
        path: 'formsAndLogsDetail',
        component: FormsLogsDetailComponent

      }, {
        path: 'DmsMainReportComponent',
        component: DmsMainReportComponent
      }, {
        path: 'drMode',
        component: DrModeComponent
      }, {
        path: 'AuditReportFindingDetailComponent/:name',
        component: AuditReportFindingDetailComponent
      }, {
        path: 'overalldashboard',
        component: OveralldashboardComponent
      }, {
        path: 'findingDueDate/:name',
        component: FindingDueDateComponent
      }, {
        path: 'followupDueDate/:name',
        component: FollowupDueDateComponent
      }, {
        path: 'calendarPage',
        component: CalendarComponent
      }, {
        path: 'notifications',
        component: UserNotificationsComponent
      }, {
        path: 'OneQMSDashboard',
        component: OneQMSDashboardComponent
      }, {
        path: 'FormsAndLogsReports',
        component: FormsAndLogsReportsComponent
      }, {
        path: 'FormsAndLogsMoreReports',
        component: FormsAndLogsMoreReportsComponent
      }, {
        path: 'feedbackTemplate',
        component: FeedbackTemplateComponent
      }, {
        path: 'feedbackTemplateDetail',
        component: FeedbackTemplateDetailComponent
      }, {
        path: 'parallelworkflowDetails',
        component: ParallelWorkflowDetailComponent

      }, {
        path: 'reportHeaderTemplate',
        component: DocumentHeaderTemplateComponent

      }, {
        path: 'qmsOOS',
        component: OosComponent
      }, {
        path: 'lab-investigation-template',
        component: OosLabInvestigationTemplateComponent
      }, {
        path: 'lab-investigation-template-category',
        component: OosLabInvestigationCategoryComponent
      }, {
        path: 'impact-assessment-template',
        component: ImpactAssessmentTemplateComponent
      }, {
        path: 'impact-assessment-fields',
        component: ImpactAssessmentFieldsComponent
      }, {
        path: 'instrument-master',
        component: InstrumentMasterComponent
      }, {
        path: 'checklist-template',
        component: ChecklistTemplateComponent
      }, {
        path: 'checklist-fields',
        component: ChecklistFieldsComponent
      }, {
        path: 'organisation-printers',
        component: OrgPrintersComponent
      },
      {
        path: 'esignatureSetup',
        component: EsignatureSetupComponent,
      },
      {
        path: 'esignatureSign',
        component: EsignatureSignComponent,
      },
      {
        path: 'businessArea', loadChildren: () => import('./business-area/business-area.module').then(m => m.BusinessAreaModule)

      }
    ]
  },

  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  { path: 'code', redirectTo: 'login', pathMatch: 'full' },

];



@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
